import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { faArrowUpArrowDown, faBell, faChevronRight, faCommentSms, faDownload, faFile, faFilePen, faHardDrive, faInfoCircle, faKey, faList, faLocationDot, faMemoPad, faMobileNotch, faMobileSignalOut, faShareNodes, faTags, faUserGroup, faUsersMedical, faWifi, faXmark, faFileAlt } from "@fortawesome/pro-regular-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useAuth } from "@qure/qure-auth";
import classNames from "classnames";
import { t } from "i18next";
import { get } from "lodash";
import { useRouter } from "next/router";
import { useStoreState } from "pullstate";
import { useContext, useState } from "react";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import { getCurrentRegion, getIsOnpremise, getIsPatientDeletionEnabled, hasSiteKeyword, isWebView } from "../../utils";
import { trackEvent } from "../../utils/mixpanel";
import AwesomeIcon from "../AwesomeIcon";
import Store from "../../utils/Store";
import React, { useMemo } from "react";
import { GatewayContext } from "../GatewayIndicator/GatewayContext";
import UserBio from "./UserBio";
import constants from "../../utils/constants";
import Toggle from "../common/Toggle";
import useSaveNotificationSettings from "../NotificationSettings/services/useSaveNotificationSettings";
import Toast from "../Toast";
import useWorkspacePermittedData from "../WorkspaceManagement/services/useWorkspacePermittedData";
import TermsAndConditionsModal from "../TermsAndConditionsModal";
import { subscribeUserNotification } from "../../utils/pushNotification";
import Loader from "../Loader";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { LicenseContext } from "../LicenseManager/LicenseContext";
import getEnv from "../../utils/getEnv";
var NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT = getEnv("NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT") === "true";
var SettingsMenu = function SettingsMenu(props) {
  var _window, _window2;
  var onLogout = props.onLogout,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    onChange = props.onChange,
    selected = props.selected;
  var _useState = useState(false),
    showTermsAndConditionsModal = _useState[0],
    setShowTermsAndConditionsModal = _useState[1];
  var _useState2 = useState(false),
    isSubscribeLoading = _useState2[0],
    setSubscribeLoading = _useState2[1];
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var _useContext = useContext(GatewayContext),
    offlineGatewayCount = _useContext.offlineGatewayCount,
    totalGateway = _useContext.totalGateway;
  var router = useRouter();
  var _useContext2 = useContext(LicenseContext),
    alertDetails = _useContext2.alertDetails;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo,
    refetchProfile = _useAuth.refetchProfile,
    isProfileLoading = _useAuth.isLoading;
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        isNotificationSubscribing: store.isNotificationSubscribing,
        isDarkMode: store.isDarkMode,
        isExportReady: store.isExportReady,
        downloadProgress: store.downloadProgress,
        isStartingDownload: store.isStartingDownload,
        exportGenFailed: store.exportGenFailed,
        isRNTestBuild: store.isRNTestBuild,
        RNSelectedEnv: store.RNSelectedEnv,
        RNfcmToken: store.RNfcmToken,
        fcmToken: store.fcmToken,
        isDiskSpaceWarning: store.isDiskSpaceWarning
      };
    }),
    isNotificationSubscribing = _useStoreState.isNotificationSubscribing,
    isDarkMode = _useStoreState.isDarkMode,
    isExportReady = _useStoreState.isExportReady,
    downloadProgress = _useStoreState.downloadProgress,
    isStartingDownload = _useStoreState.isStartingDownload,
    exportGenFailed = _useStoreState.exportGenFailed,
    isRNTestBuild = _useStoreState.isRNTestBuild,
    RNSelectedEnv = _useStoreState.RNSelectedEnv,
    RNfcmToken = _useStoreState.RNfcmToken,
    fcmToken = _useStoreState.fcmToken,
    isDiskSpaceWarning = _useStoreState.isDiskSpaceWarning;
  var saveNotificationSettings = useSaveNotificationSettings();
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var isNotificationOn = !isLoggedIn || !get(userInfo, ["settings", "notification_snoozed"], false);
  var token = RNfcmToken || fcmToken;
  var hasPermission = isMobileApp && !!RNfcmToken || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Notification) === null || _window2 === void 0 ? void 0 : _window2.permission) === "granted";
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || get(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return get(tokenObj, ["token"], "") === token;
  });
  var isLicenseEnabled = get(userInfo, ["settings", "is_licensing_enabled"], false);
  // qTrack patient SMS — account-level ui_settings.sms gates both the chat SMS
  // button and the "SMS Configuration" settings entry (user-level, no per-workspace gate).
  var isSmsEnabled = get(userInfo, ["settings", "ui_settings", "sms"], false);
  var isACREnabled = get(userInfo, ["settings", "ui_settings", "is_acr_enabled"], false);

  // Fetch workspaces where user has management permission (admin only)
  var _useWorkspacePermitte = useWorkspacePermittedData(true, constants.WORKSPACE_USER_ROLES.WORKSPACE_MANAGEMENT),
    _useWorkspacePermitte2 = _useWorkspacePermitte.data,
    managementWorkspaces = _useWorkspacePermitte2 === void 0 ? [] : _useWorkspacePermitte2;

  // Check if user is admin of default workspace
  var isWorkspaceAdmin = useMemo(function () {
    if (!managementWorkspaces || managementWorkspaces.length === 0 || !(userInfo !== null && userInfo !== void 0 && userInfo.default_workspace)) return false;

    // Check if default workspace is in the list of workspaces where user has admin access
    return managementWorkspaces.some(function (ws) {
      return ws.id === userInfo.default_workspace && ws.role === "admin";
    });
  }, [managementWorkspaces, userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace]);
  var settings = [{
    pageName: constants.SETTINGS.NOTIFICATIONS,
    section: "user_settings",
    icon: faBell,
    className: classNames({
      hidden: isOnpremise
    }),
    control: function control() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("flex sm:hidden items-center border-l border-gray-800 p-4 gap-4")
      }, /*#__PURE__*/React.createElement("div", null, t("settings.on")), /*#__PURE__*/React.createElement(Toggle, {
        value: isNotificationOn,
        onChange: onToggleNotification,
        disabled: !isSubscribed || !hasPermission || saveNotificationSettings.isLoading || isProfileLoading || isNotificationSubscribing
      }));
    }
  }, {
    pageName: constants.SETTINGS.WORKLIST_TAGS,
    section: "user_settings",
    icon: faList
  }, {
    pageName: constants.SETTINGS.FORM_TEMPLATES,
    section: "user_settings",
    icon: faMemoPad
  }, {
    pageName: constants.SETTINGS.AUTOMATED_SHARING,
    section: "user_settings",
    icon: faShareNodes,
    className: classNames({
      hidden: isOnpremise
    })
  }, {
    pageName: constants.SETTINGS.USER_GROUPS,
    section: "user_settings",
    icon: faUserGroup,
    className: classNames({
      hidden: isOnpremise
    })
  }, {
    pageName: constants.SETTINGS.CUSTOM_TAGS_MANAGEMENT,
    section: "user_settings",
    icon: faTags,
    className: classNames({
      hidden: isOnpremise
    })
  }, {
    pageName: hasSiteKeyword() ? constants.SETTINGS.SITE_MANAGEMENT : constants.SETTINGS.WORKSPACE_MANAGEMENT,
    section: "user_settings",
    icon: faUsersMedical,
    className: classNames({
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.REPORT_TEMPLATE,
    section: "user_settings",
    icon: faFile,
    className: classNames({
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.LETTER_TEMPLATE,
    section: "user_settings",
    icon: faFilePen,
    customLabel: "Communication templates",
    className: classNames({
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.SMS_TEMPLATES,
    section: "user_settings",
    icon: faCommentSms,
    customLabel: "SMS Configuration",
    className: classNames({
      hidden: isMobile || !isSmsEnabled
    })
  }, {
    pageName: constants.SETTINGS.ACR_REGISTRATION,
    section: "user_settings",
    icon: faFileAlt,
    className: classNames({
      hidden: isMobile || !isACREnabled
    })
  }, {
    pageName: constants.SETTINGS.DISK_MANAGEMENT,
    section: "user_settings",
    icon: faHardDrive,
    className: classNames({
      hidden: isMobile || !(isOnpremise && isPatientDeletionEnabled)
    }),
    control: function control() {
      if (isDiskSpaceWarning) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames("flex items-center p-4 gap-4")
        }, /*#__PURE__*/React.createElement(AwesomeIcon, {
          name: faTriangleExclamation,
          className: "text-yellow-500"
        }));
      }
      return null;
    }
  }, {
    pageName: constants.SETTINGS.LICENSE_MANAGER,
    section: "user_settings",
    icon: faKey,
    control: function control() {
      if (alertDetails !== null && alertDetails !== void 0 && alertDetails.isAlert) {
        return /*#__PURE__*/React.createElement(AwesomeIcon, {
          name: faTriangleExclamation,
          className: "text-yellow-500 mr-5"
        });
      }
      return null;
    },
    className: classNames({
      hidden: isMobile || !isOnpremise || !isLicenseEnabled
    })
  }, {
    pageName: constants.SETTINGS.EXPORT_DATA,
    section: "more",
    icon: faDownload,
    control: function control() {
      var status = /*#__PURE__*/React.createElement("div", {
        className: "text-sm uppercase"
      }, t("settings.download"));
      if (isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady) {
        status = /*#__PURE__*/React.createElement("div", {
          className: "w-6 h-6"
        }, /*#__PURE__*/React.createElement(CircularProgressbar, {
          value: downloadProgress,
          styles: buildStyles({
            rotation: 0.25,
            strokeLinecap: "butt",
            textSize: "24px",
            pathTransitionDuration: 0.5,
            pathColor: "rgba(0, 130, 128)",
            textColor: "#f88",
            trailColor: isDarkMode ? "white" : "#b6aeae",
            backgroundColor: "white"
          })
        }));
      } else if (exportGenFailed) {
        status = /*#__PURE__*/React.createElement("div", {
          className: "flex text-md text-red-600 dark:text-red-400 font-normal"
        }, t("settings.export_failed"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer mr-3"
      }, status);
    },
    onClick: function onClick(pageName) {
      Store.update(function (s) {
        s.showExportUpdate = isExportReady;
        s.isExportDataOpen = !isExportReady && (downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload;
        s.isSettingsOpen = false;
      });
      trackEvent(MIXPANEL_EVENTS.SELECT_SETTING, {
        pageName: pageName
      });
    },
    className: classNames({
      "opacity-50": isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady,
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.GATEWAY,
    section: "more",
    icon: faArrowUpArrowDown,
    count: offlineGatewayCount,
    className: classNames({
      hidden: !totalGateway
    })
  },
  // {
  //   pageName: constants.SETTINGS.MODALITY_CONNECT,
  //   section: "more",
  //   icon: faNetworkWired,
  //   className: classNames({ hidden: isMobile || isOnpremise }),
  // },
  {
    pageName: constants.SETTINGS.SCAN_TO_CONNECT,
    section: "more",
    icon: faMobileSignalOut,
    className: classNames({
      hidden: !isOnpremise || !NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT
    })
  }, {
    pageName: constants.SETTINGS.REMOTE_ACCESS,
    section: "more",
    icon: faWifi,
    className: classNames({
      hidden: !isOnpremise
    })
  }, {
    pageName: constants.SETTINGS.TERMS_OF_USE,
    section: "more",
    icon: faInfoCircle,
    className: classNames({
      hidden: !isMobile
    }),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_TERMS_OF_USE);
    }
  }, {
    pageName: constants.SETTINGS.REGION,
    customLabel: t(getCurrentRegion()),
    section: "more",
    icon: faLocationDot,
    viewOnly: true,
    className: classNames("cursor-default", {
      hidden: isOnpremise || !isMobile
    })
  }];
  var onToggleNotification = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
      var payload, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            payload = {
              notification_snoozed: !value
            };
            _context.n = 1;
            return saveNotificationSettings.mutateAsync(payload);
          case 1:
            _context.n = 2;
            return refetchProfile();
          case 2:
            trackEvent(MIXPANEL_EVENTS.UPDATE_NOTIFICATION_SETTINGS, {
              notification_snoozed: payload.notification_snoozed
            });
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            Toast.error("Something went wrong. Please retry");
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function onToggleNotification(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onChangeSetting = function onChangeSetting(pageName) {
    if (onChange) {
      onChange(pageName);
    } else {
      router.push("/settings/".concat(pageName), undefined, {
        shallow: true
      });
    }
    trackEvent(MIXPANEL_EVENTS.SELECT_SETTING, {
      pageName: pageName
    });
  };
  var onUpdateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _window3, data, subscription;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!(isMobileApp && !hasPermission)) {
              _context2.n = 1;
              break;
            }
            data = {
              event: constants.RN_COMM_CONST.OPEN_APP_SETTINGS,
              data: null
            };
            (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.ReactNativeWebView) === null || _window3 === void 0 || _window3.postMessage(JSON.stringify(data));
            _context2.n = 5;
            break;
          case 1:
            setSubscribeLoading(true);
            _context2.n = 2;
            return subscribeUserNotification(RNfcmToken);
          case 2:
            subscription = _context2.v;
            if (!subscription) {
              _context2.n = 4;
              break;
            }
            _context2.n = 3;
            return refetchProfile();
          case 3:
            setSubscribeLoading(false);
          case 4:
            setSubscribeLoading(false);
          case 5:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function onUpdateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _section = "";
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col h-full bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 w-full sm:w-2/5", {
      "pt-6": isWebView()
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start p-4 sm:pl-6 text-lg border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "flex sm:hidden p-4"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "h-6 w-6 "
  })), /*#__PURE__*/React.createElement("div", null, t("settings_key"))), !isOnpremise && isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, (!hasPermission || !isSubscribed) && /*#__PURE__*/React.createElement("div", {
    className: "inline bg-yellow-900 text-md p-4 py-5"
  }, isSubscribeLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: "Please wait",
    className: "mr-3",
    containerClassName: "!py-0 flex !flex-row"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "pr-2"
  }, t("notification_modal.no_notifications_setting")), /*#__PURE__*/React.createElement("span", {
    className: "text-yellow-400 font-bold cursor-pointer",
    onClick: onUpdateSubscription
  }, t("notification_modal.update_settings"))))), /*#__PURE__*/React.createElement(UserBio, {
    onLogout: onLogout
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-auto scrollbar-light dark:scrollbar"
  }, settings.map(function (_setting, idx) {
    var _setting$className = _setting.className,
      className = _setting$className === void 0 ? "" : _setting$className,
      section = _setting.section,
      pageName = _setting.pageName,
      count = _setting.count,
      icon = _setting.icon,
      viewOnly = _setting.viewOnly,
      control = _setting.control,
      _onClick = _setting.onClick,
      customLabel = _setting.customLabel;
    var header = null;
    if (section !== _section) {
      _section = section;
      header = /*#__PURE__*/React.createElement("div", {
        key: section,
        className: "flex items-center font-semibold uppercase text-gray-800 dark:text-gray-300 py-3 px-5 mt-3"
      }, t("settings.".concat(section)), /*#__PURE__*/React.createElement("hr", {
        className: "flex grow border-gray-300 dark:border-gray-700 ml-3"
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: pageName
    }, header, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex items-center justify-between ", _defineProperty({
        "hover:bg-gray-200 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200 cursor-pointer": !viewOnly,
        "bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200": pageName === selected
      }, className, !!className)),
      "data-testid": "".concat(pageName, "-setting"),
      onClick: function onClick() {
        if (!viewOnly) {
          if (_onClick) {
            _onClick(pageName);
          } else {
            onChangeSetting(pageName);
          }
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex py-4 items-center justify-between px-5 w-full", {})
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, count && count > 0 && /*#__PURE__*/React.createElement("div", {
      className: "absolute border-gray-800 flex justify-center items-center text-sm rounded-full bg-red-600 text-gray-100 right-4 font-medium -top-1 w-5 h-5"
    }, count), icon && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: icon,
      size: "lg",
      className: "mr-5 w-6"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start whitespace-nowrap"
    }, customLabel || t("settings.".concat(pageName)))), /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faChevronRight,
      size: "lg",
      className: classNames("sm:hidden justify-self-end", {
        hidden: viewOnly
      })
    })), control && control()));
  }), !!isRNTestBuild && /*#__PURE__*/React.createElement("div", {
    className: "",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isRNEnvSelectorOpen = true;
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 items-center justify-start"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMobileNotch,
    className: "h-6 w-6 mr-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, "Debug Environment"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start text-sm"
  }, RNSelectedEnv))))), showTermsAndConditionsModal && /*#__PURE__*/React.createElement(TermsAndConditionsModal, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    },
    showModal: showTermsAndConditionsModal
    // closeOnClickAway
    ,
    mode: "readonly"
  }));
};
export default SettingsMenu;